import {Backbone} from 'Vertebrae';
import {ProfileAffinityGroup as AffinityGroup} from 'model/profileAffinityGroup';

export const ProfileAffinityGroups = Backbone.Collection.extend({
    _name: 'AffinityGroups',
    model: AffinityGroup,
    url: '/profile/groups/get.json',
});
